import { useQuery } from "@tanstack/react-query";
import { getInstanceByResourceList } from "../../api/apiCallManager";

export const useSearchInstances = (
  cpuValue,
  memValue,
  apiRegion,
  resourceTypeInput,
  gpuValue,
  infraType
) => {
  return useQuery({
    queryKey: [
      "filteredInstancesSearch_",
      cpuValue,
      memValue,
      apiRegion,
      resourceTypeInput, // Added missing resourceTypeInput to query key
      gpuValue,
      infraType,
    ], // Query key
    queryFn: async () => {
      const dataResponse = await getInstanceByResourceList(
        cpuValue,
        memValue,
        apiRegion,
        resourceTypeInput,
        gpuValue,
        infraType
      );
      // console.log("-========>", dataResponse);
      const insData = dataResponse?.map((item, index) => ({
        ...item,
        key: `${index + 1}inst`,
      }));

      return insData.filter(
        (instance) => parseFloat(instance["CostPerHour(USD)"]) > 0
      );
    },

    onError: (error) => {
      console.error("Error fetching data:", error);
    },
    enabled: !!memValue && !!apiRegion,
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes to prevent unnecessary refetches
    refetchOnMount: false, // Don't refetch on mount if data is fresh
    refetchOnWindowFocus: false, // Already disabled globally, but explicit here
    // enabled: false,
  });
};
